require.register("app/restaurant/show/AnalyseTab", function(exports, require, module){
  $0
  
});

